// Spanish (Español)
export default {
  tip: {
    fromSuccess: "Enviado con éxito",
  },
  login: {
    linkList: [
      { name: "Centro Comercial de Puntos", url: "/" },
      {
        name: "Regístrese como trader",
        url: "https://tw.fisg.com/register/trader?link_id=ct01egz0&referrer_id=v4w8jplv",
      },
    ],
    registered: {
      text: "¿No tienes cuenta? Haz clic para registrarte >>",
      url: "https://tw.fisg.com/register/trader?link_id=ct01egz0&referrer_id=v4w8jplv",
    },
    shouye: {
      url: "/",
    },
    forgot: "¿Olvidaste tu contraseña?",
    title: "Iniciar sesión",
    email: "Correo electrónico",
    pwd: "Contraseña",
    denglu: "Ingresar",
    mima: "Olvidé mi contraseña",
    Reset: "Restablecer contraseña",
    p_email: "Por favor, ingrese su correo electrónico",
    p_pwd: "Por favor, ingrese su contraseña",
    p_new_pwd: "Por favor, ingrese su nueva contraseña",
    z_email: "Por favor, ingrese un correo electrónico válido",
    long: "La longitud debe tener entre 6 y 18 caracteres",
    determine: "Confirmar",
    Valid:
      "La solicitud de restablecimiento ha sido enviada. Por favor, revise su correo. ¡El enlace es válido por 24 horas!",
    Help_reset:
      "Ingrese su correo electrónico registrado y le ayudaremos a restablecer su contraseña.",
  },
  myhead: {
    loginName: "Iniciar sesión",
    Personalcenter: "Centro personal",
    placeholder: "Por favor, ingrese...",
    myhead_a: "Inicio",
    myhead_b: "Operar",
    myhead_bc: "Plataforma de trading",
    myhead_c: "Plataforma",
    myhead_d: "Academia de trading",
    myhead_e: "Sobre nosotros",
    myhead_f: "Le ayudamos",
    myhead_g: "A ser el mejor trader",
    myhead_h: "Abrir cuenta real",
    myhead_i: "Empezar con cuenta demo",
    myhead_j: {
      text: "Actividades de mercado",
      url: "https://www.interstellarfx.net/zh/trade-cashback",
    },
    myhead_k: "Reembolso por trading",
    myhead_l: "Productos de trading",
    myhead_m: "Relacionado con el trading",
    myhead_n: "Escuela de Forex",
    myhead_o: "Evento de recompensas de puntos",
    myhead_p: "Anuncios",
    myhead_q: "Pronóstico del mercado",

    myhead_r:
      "Los CFDs son instrumentos complejos y conllevan un alto riesgo de perder dinero rápidamente debido al apalancamiento. La mayoría de las cuentas de inversores minoristas pierden dinero al operar con CFDs. Debe considerar si comprende cómo funcionan los CFDs y si puede permitirse asumir el alto riesgo de perder su dinero.",
    myhead_s: "Empresa",
    myhead_t: "Mercado",
    myhead_u: "Cotizaciones",
    myhead_v: "Análisis y Educación",
    myhead_v_a: "Análisis",
    myhead_v_b: "Educación",
    myhead_w: "Regulación",
    myhead_x: "Seguro",
    myhead_y: "Cumplimiento legal",
    myhead_z: "Últimas noticias",
    myhead_aa: "Guía de trading",
    myhead_bb: "Glosario de trading",
    myhead_cc: "Noticias en tiempo real",
    myhead_dd: "Análisis de trading",
    myhead_ee: "Inversión en Forex",
    myhead_ff: "Patrocinio y Responsabilidad Social",
    myhead_gg: "Seminario web en línea",
    myhead_hh: "Análisis FISG",
    myhead_ii: "Curso de trading",
    myhead_com: "Competencia de trading demo",
  },
  Home: {
    Home_a: "Centro Comercial de Puntos",
    Home_b: "¡Opere para ganar puntos y canjear grandes premios!",
    Home_c:
      "Canjee sus puntos por regalos: tecnología digital, electrodomésticos, autos de lujo y más...",
    Home_d: "Ver términos y condiciones aplicables",
    Home_e: "Clic",
    Home_f: "aquí",
    Home_g: "Grandes premios te esperan",
    Home_h: "¿No encuentra el regalo que desea?",
    Home_i:
      "Recomiéndenos los productos que desee; agregaremos artículos según su popularidad...",
    Home_j: "Marca del regalo: ej. Xiaomi, Huawei...",
    Home_k: "Descripción: ej. Scooter eléctrico Xiaomi Plus...",
    Home_l: "Enviar",
    Home_m: "Reglas de canje de puntos",
    Home_n: "Cómo obtener puntos",
    Home_o:
      "Cualquier cliente de FISG que opere pares de divisas, metales preciosos y energía en nuestra plataforma obtendrá 1 punto por cada lote (órdenes de más de 3 minutos).",
    Home_p: "Cómo canjear regalos",
    Home_q:
      "Envíe una solicitud en el centro de puntos (nombre, contacto, cuenta de trading). Revisaremos sus puntos y comportamiento comercial para aprobar el envío.",
    Home_r: "Tiempo de entrega",
    Home_s:
      "Los regalos se enviarán dentro de los 15 días posteriores a la aprobación. Puede consultar el progreso con su gerente de cuenta.",
    Home_t: "Servicio posventa",
    Home_u:
      "Los productos son de terceros y no admiten devoluciones sin motivo. Si hay daños o errores en el envío, contacte a soporte.",
    Home_v: "Recomendaciones populares",
    Home_w:
      "Las mejores marcas están aquí. Canjee sus puntos FISG por los productos más populares.",
    Home_x: "Canjear ahora",
    Home_y: "Puntos",
    Home_z: "Marcas seleccionadas",
    Home_aa: "Nuevos productos",
    Home_bb: "Ordenar por puntos",
    Home_cc: "Marcas destacadas",
    Home_dd: "Solo necesitas",
    Home_ee: "puntos para canjear",
    Home_ff: "Ingrese la marca del regalo",
    Home_gg: "Ingrese la descripción del producto",
    Home_hh: "Éxito",
    Home_hh: "Términos",
    Home_ii: "Éxito",
    Home_zz: "Centro Comercial de Puntos",
    Home_kk: "Tienda de puntos",
    Home_search: "Buscar productos",
    seckill: "Oferta relámpago",
    daySeckill: "Horario diario de ofertas",
    cutDownTips: "Cuenta regresiva para caja sorpresa",
    cutDownTips1: "Venta de caja sorpresa terminada",
    cutDownTips2: "Fuera del horario de venta",
    cutDownTips3: "El evento no ha comenzado",
  },
  detail: {
    detail_a: "Volver al inicio",
    detail_b: "Modelo",
    detail_c: "Cantidad",
    detail_d: "Instrucciones de canje",
    detail_e:
      "Los regalos se enviarán dentro de los 15 días posteriores a la aprobación. Por favor, esté atento a la entrega.",
    detail_f:
      "Los productos son de terceros. No hay devoluciones sin motivo, pero resolvemos problemas de daños o errores de envío.",
    detail_g: "Detalles del producto",
    detail_h: "Recomendaciones populares",
    detail_i: "Por favor inicie sesión",
  },
  settlement: {
    balance: "Saldo de puntos",
    settlement_a: "Información del pedido",
    settlement_b: "Nombre",
    settlement_c: "Especificación",
    settlement_d: "Precio unitario",
    settlement_e: "Cantidad",
    settlement_f: "Información del destinatario",
    settlement_g: "Añadir dirección",
    settlement_h: "Monto a pagar",
    settlement_i: "Puntos",
    settlement_z: "Enviar ahora",
    settlement_k: "Enviado con éxito",
    settlement_l: "¡Por favor confirme su pedido!",
    settlement_m: "Producto",
    settlement_n: "¡Información del producto!",
    settlement_o: "¡Información de puntos!",
    settlement_p: "Puntos insuficientes",
    settlement_title: "¡Canje exitoso!",
    settlement_tip:
      "Su pedido se entregará en un plazo de 15 días hábiles. Puede consultar con su gerente de cuenta.",
    settlement_button: "Aceptar",
    settlement_button_err: "Aceptar",
    settlement_tip_error:
      "Cómo obtener puntos: 1 punto por cada lote operado en divisas, metales y energía (mínimo 3 minutos de permanencia).",
  },
  meber: {
    meber_a: "Centro de pedidos",
    meber_b: "Centro personal",
    meber_c: "Mis pedidos",
    meber_d: "Gestión de direcciones",
    meber_e: "Cerrar sesión",
  },

  address: {
    address_a: "Añadir",
    address_b: "Nombre",
    address_c: "Teléfono",
    address_d: "Dirección",
    address_e: "Operación",
    address_f: "Editar",
    address_g: "Eliminar",
    address_h: "Por favor seleccione",
    address_i: "Dirección detallada",
    address_j: "Guardar",
    address_k: "Ingrese su nombre",
    address_l: "Ingrese su teléfono",
    address_m: "Formato de teléfono incorrecto",
    address_n: "Ingrese su número de móvil",
    address_o: "Ingrese la dirección detallada",
    address_p: "Modificado con éxito",
    address_q: "Añadido con éxito",
    address_r: "Eliminado con éxito",
    address_s: "Nueva dirección de envío",
    address_t: "Aún no ha añadido una dirección",
  },

  order: {
    order_a: "Mis pedidos",
    order_b: "Fecha",
    order_c: "Número de pedido",
    order_d: "Destinatario",
    order_e: "Monto",
    order_f: "Detalles del pedido",
    order_g: "Teléfono",
    order_h: "Dirección",
    order_i: "Estado",
    order_j: "Método de envío",
    order_k: "Operación",
    order_l: "Cerrado",
    order_m: "Creado",
    order_n: "Pagado",
    order_o: "Reembolsando",
    order_p: "Reembolsado",
    order_q: "Enviado",
    order_r: "Completado",
    order_s: "Puntos gastados",
  },

  userinfo: {
    userinfo_a: "Centro personal",
    userinfo_b: "Última actualización",
    userinfo_c: "Correo del usuario",
    userinfo_d: "Puntos disponibles",
  },

  orderDetail: {
    orderDetail_a: "Pedido enviado",
    orderDetail_b: "Pago exitoso",
    orderDetail_c: "Producto en salida",
    orderDetail_d: "Esperando recepción",
    orderDetail_e: "Completado",
    orderDetail_f: "Método de pago",
    orderDetail_g: "Método de envío",
    orderDetail_h: "Número de seguimiento",
  },

  footerbox: {
    footerbox_b: "Mercado global de hoy",
    footerbox_c: "Pruebe una demo gratuita",
    footerbox_d: "Soporte Asia-Pacífico (Singapur)",
    footerbox_e: "Correo de la empresa",
    footerbox_f: "support@interstellarsfx.com",

    footerbox_g: "Empezar a operar",
    footerbox_h: "Forex",
    footerbox_i: "Metales preciosos",
    footerbox_ik: "Acciones",
    footerbox_j: "Energía",
    footerbox_k: "Índices",
    footerbox_a: "Sobre el trading",

    footerbox_l: "Cuenta",
    footerbox_m: "Tipos de cuenta",
    footerbox_ml: "Política de apalancamiento",
    footerbox_n: "Depósitos y Retiros",
    footerbox_o: "Abrir cuenta real",
    footerbox_p: "Abrir cuenta demo",

    footerbox_q: "Herramientas de trading",
    footerbox_r: "MetaTrader 4",
    footerbox_s: "MAM",
    footerbox_t: "MultiTerminal",
    footerbox_u: "Calendario económico",
    footerbox_v: "Calculadora de Forex",
    footerbox_w: "VPS",
    footerbox_x: "Análisis técnico",

    footerbox_y: "Academia de trading",
    footerbox_z: "Glosario de trading",

    footerbox_aa: "Sobre nosotros",
    footerbox_ad: "Quiénes somos",
    footerbox_bb: "Noticias",
    footerbox_cc: "Carreras",
    footerbox_dd: "Contáctenos",
    footerbox_ee: "Socios",
    footerbox_ff: "Preguntas frecuentes",

    footerbox_mm: "Descargo de responsabilidad: ",
    footerbox_nn: `El sitio web www.interstellarsfx.com es operado por First Interstellar Global Ltd, una sociedad de responsabilidad limitada constituida bajo las leyes de Seychelles. Room 9, Deenu's Building, Providence, Mahe, Seychelles. First Interstellar Global Ltd está autorizada y regulada por la Autoridad de Servicios Financieros de Seychelles (FSA) con el número SD127. No pertenece al marco regulatorio europeo (MiFID II) y no se aplican los esquemas de compensación de inversores de la UE.`,
    footerbox_gg:
      "No ofrecemos servicios a residentes de ciertas jurisdicciones como EE. UU., Irán, Canadá, Bélgica y Francia.",
    footerbox_hh: "Advertencia de riesgo:",
    footerbox_ii:
      "Operar con divisas y productos financieros apalancados conlleva un alto riesgo de pérdida de capital. No debe arriesgar más de lo que puede permitirse perder. Asegúrese de comprender los riesgos involucrados. El rendimiento pasado no garantiza resultados futuros. Busque asesoramiento financiero independiente si es necesario.",
    footerbox_zz: "Declaración de riesgo",
    footerbox_kk: "Política de privacidad",
    footerbox_ll: "Copyright © 2025 FISG. Todos los derechos reservados.",
  },
  other: {
    sections: {
      about: "Acerca de FISG",
      trading: "Operaciones",
      campaigns: "Campañas",
      education: "Educación",
      markets: "Mercados",
    },
    about: {
      title: "First InterStellar Group",
      aboutFISG: "Acerca de FISG",
      legalCompliance: "Cumplimiento Legal",
      clientReviews: "Reseñas de Clientes",
      insurance: "Seguro",
      events: "Eventos InterStellar",
      partnership: "Asociación",
    },
    trading: {
      platformTitle: "Plataforma de Operaciones",
      mt4: "MetaTrader 4",
      mt5: "MetaTrader 5",
      webTerminal: "MetaTrader WebTerminal",
      copyTrade: "Copy Trade",
      app: "FISG APP",
      marketsTitle: "Mercados para Operar",
      forex: "Forex",
      metals: "Metales",
      energy: "Energía",
      index: "Índice",
      stock: "Acciones",
      cryptocurrency: "Criptomonedas",
      accountTitle: "Cuenta",
      accountTypes: "Tipos de Cuentas",
      leverage: "Política de Apalancamiento",
      depositWithdrawal: "Depósito y Retiro",
      toolsTitle: "Herramientas de Trading",
      mam: "MAM",
      pamm: "PAMM",
      multiTerminal: "MultiTerminal",
      calculator: "Calculadora Forex",
    },
    campaigns: { title: "Campañas" },
    education: {
      title: "Educación",
      seminar: "Seminario",
      whatIsForex: "¿Qué es el Trading de Forex?",
      course: "Curso de Trading",
      investment: "Inversión en Forex",
      glossary: "Glosario de Términos de Trading",
      faq: "Preguntas Frecuentes",
    },
    markets: {
      title: "Mercados",
      notices: "Avisos de FISG",
      analysis: "Análisis de FISG",
      calendar: "Calendario Económico",
      transaction: "Análisis de Transacciones",
      news: "Noticias de Última Hora",
      times: "FISG Times",
      marketWrap: "Market Wrap",
    },
    ctaTradeNow: "OPERAR AHORA",
    login: "Iniciar Sesión",

    topTips1: "1 punto es igual a 1 lote estándar o 100 lotes cent.",
    topTips2: "No se aceptan canjes transregionales.",
    topTips3:
      "Confirmo que el volumen de trading coincide con los puntos del sistema y he completado el canje.",
    topTips4:
      "Entiendo que si los puntos son incorrectos debido a un error del sistema, el canje será nulo.",
    remark: "Observaciones",

    confirmAddress: "Confirmar dirección",
    cancel_btn: "Cancelar",

    setAsDefault: "Establecer por defecto",
    exchangeAccount: "Cuenta de canje",

    defaultAddress: "Predeterminado",

    exchangeAccount1: "Seleccionar cuenta de trading",

    exchangeAccount2:
      "Seleccione la cuenta de trading para recibir el premio en efectivo",
  },
}
